/* RESPONSIBLE TEAM: team-inbox-management */
export const MAX_CONDITIONS_PER_DESCRIPTOR = 100;
